<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img14.jpg"/></p>
<p class="chap"><a id="ch6"></a>LOST COLONY I, 1585</p>
<p class="noindent"><span class="big">T</span>wice in the 1580s, the English tried to establish a colony at Roanoke Island on the coast of Carolina. Twice they failed. After the initial voyages of John Cabot in the 1490s, interest in America waned. Late in the reign of Elizabeth I, tensions with Spain made a North American military outpost desirable if not a necessity. Leading this effort was Sir Walter Raleigh, the handsome son of a prominent family. He had distinguished himself fighting in France and Ireland and was one of the Queen’s favorites. In 1585, he sent a 108-man expedition to plant the flag on tiny Roanoke Island off the coast of present day North Carolina. Unfortunately, Roanoke had barren soil and poor water supply, and it was located in the dangerous waters of Cape Hatteras.</p>
<p class="indent">On this first attempt, the settlers arrived at mid-summer and were saved from starvation by the Roanoke clan, part of the Native American Algonquian confederation. <span class="color">(04-014, 04-015, 04-016)</span></p>
<p class="image"><img alt="image" src="images/img15.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter006.vue?254c08db